export const ZAPPOS_REBRAND_REPLACEMENT_COLORS = {
  '#e7f4ff': '#fcf8e7' // Light blue to light yellow. Uses: BannerItem
} as const;
